'use client';

import { useSearch } from '../core/SearchContext';
import { splitByMatch } from '../utils/highlight';

/** `text` with the typed query set in semibold blue wherever it appears (Figma `#398cff`). */
export function Highlight({ text }: { text: string }) {
  const { query } = useSearch();
  return (
    <>
      {splitByMatch(text, query).map((part, i) =>
        part.match ? (
          <span key={i} className="font-semibold text-v2-bg-blue">
            {part.text}
          </span>
        ) : (
          part.text
        ),
      )}
    </>
  );
}
